import { TEXT_ELEMENT, TextComponent } from '@abiglobalhealth/go-types'
import { useMemo } from 'react'

import { useUser } from '@/hooks/useUser'
import i18n from '@/locale/i18n'
import { getSlugTranslation, getSlugTranslationKeys } from '@/locale/utils'

export type TextProps = Omit<TextComponent, 'componentType'>

export const Text = ({ id, element, textKey, justify }: TextProps) => {
  const { user } = useUser()
  const translationKeys = getSlugTranslationKeys(textKey)

  const translation = useMemo(
    () =>
      getSlugTranslation(textKey, {
        ...user?.data
      }),
    [textKey, user?.data]
  )

  if (!i18n.exists(translationKeys)) {
    console.warn(`Text key ${textKey} not found`)
    return null
  }

  switch (element) {
    case TEXT_ELEMENT.TITLE:
      // We use h2 because it can be more than one title element on a step
      return (
        <h2 id={id} className={`font-bold ${justify ? `text-${justify}` : ''}`}>
          {translation}
        </h2>
      )

    case TEXT_ELEMENT.BODY:
      return (
        <p
          id={id}
          className={justify ? `text-${justify}` : ''}
          dangerouslySetInnerHTML={{
            __html: translation
          }}
        />
      )

    default:
      console.error(`Text element type ${element} not supported`)
      return null
  }
}
